import { Component, OnInit, Inject } from '@angular/core';
import { Payment } from 'src/app/stores/payment.store';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PrintService } from 'src/app/services/print.service';
import { Report } from 'src/app/stores/report.store';
import { Environment } from 'src/app/stores/environment.store';
import { SCHOOL } from 'src/app/dummy/config';

@Component({
  selector: 'app-report-shift-summary-dialog',
  templateUrl: './report-shift-summary-dialog.component.html',
  styleUrls: ['./report-shift-summary-dialog.component.scss']
})
export class ReportShiftSummaryDialogComponent implements OnInit {

  exchange_rate;
  shiftData;
  school=SCHOOL

  constructor(
    public dialogRef: MatDialogRef<ReportShiftSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store: Report,
    private ps: PrintService,
    private env: Environment,
  ) { }

  async ngOnInit() {
    this.shiftData = await this.env.fetchShiftMovementDoc(this.data.key)
    this.exchange_rate = this.shiftData && this.shiftData.exchange_rate || 4000;

    this.store.fetchReceiptByTerm(this.data.key);
    this.store.fetchDialShiftCashReceiveRiels(this.data.key, (riels) => { })
    this.store.fetchDialShiftCashReceiveDollars(this.data.key, (dollars) => { })
  }

  print() {
    this.ps.print("#printD", "a4");
  }

}
